export class OrganizacionaStrukturaOrganaTree {
    idOj: number;
    nazivOj: string;
    nadredjenaOjId: number;
    podredjeneOj: OrganizacionaStrukturaOrganaTree[];
    
    constructor(idOj: number, nazivOj: string, nadredjenaOjId: number) {
        this.idOj = idOj;
        this.nazivOj = nazivOj;
        this.nadredjenaOjId = nadredjenaOjId;
    }
}

export interface OJNode {
    expandable: boolean;
    name: string;
    level: number;
    parentId: number;
    id: number;
}

